import React, { useState } from 'react';
import ChevronDownGray from "../../../../icons/Chevron-Down-Gray.svg";

type Pharmacy = {
    name: string;
    address?: string;
    email?: string;
    phone?: string;
};

type Props = {
    pharmacy: Pharmacy;
    index: number;
    onExpand?: () => void;
};

const PharmacyRow: React.FC<Props> = ({ pharmacy, index, onExpand }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleToggle = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(prev => {
            const newState = !prev;
            if (newState && onExpand) {
                onExpand();
            }
            return newState;
        });
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsOpen(prev => {
                const newState = !prev;
                if (newState && onExpand) {
                    onExpand();
                }
                return newState;
            });
        }
    };

    return (
        <div className="popup-info space-y-0 mb-3">
            <div
                className="flex items-center justify-between cursor-pointer select-none"
                role="button"
                tabIndex={0}
                aria-expanded={isOpen}
                onClick={handleToggle}
                onKeyDown={handleKeyDown}
            >
                <strong className="name block text-sm">{pharmacy.name}</strong>
                <img
                    src={ChevronDownGray}
                    alt="Toggle details"
                    className={`w-5 h-5 shrink-0 transition-transform duration-200 transform ${isOpen ? 'rotate-180' : 'rotate-0'}`}
                    style={{ pointerEvents: 'none' }}
                />
            </div>
            {isOpen && (
                <div>
                    {pharmacy.address && (
                        <p className="address !m-0 !mb-0 !mt-0 leading-tight !text-xs pl-3">{pharmacy.address}</p>
                    )}
                    {pharmacy.email && (
                        <p className="email !m-0 !mb-0 !mt-0 leading-tight !text-xs pl-3">{pharmacy.email}</p>
                    )}
                    {pharmacy.phone && (
                        <p className="phone !m-0 !mb-0 !mt-0 leading-tight !text-xs pl-3">{pharmacy.phone}</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default PharmacyRow;
